import type { ClientSdk } from "./ClientSdk"
import { resolveRoute } from "./browser/routes"

/** Talks to the remote REST API (docs.iopta.org/docs/api) directly — used when the app is opened
 * as a plain web page with no Tauri runtime present. See `browser/routes.ts` for the cmd -> REST
 * mapping. */
export class BrowserClientSdk implements ClientSdk {
  readonly kind = "browser" as const

  async invoke<T>(cmd: string, args?: Record<string, unknown>): Promise<T> {
    const handler = resolveRoute(cmd)
    return (await handler(args ?? {})) as T
  }
}
